import React, {useContext, useMemo} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LinkDuo from "components/LinkDuo";
import DrawerItem from "components/Shared/MSidebar/DrawerItem";
import useTo from "components/Shared/MSidebar/utility/useTo";
import context from "components/Shared/MSidebar/utility/context";

const homePaths = [
  "/",
  "/refresh",
];

const DrawerLink = ({
  item: {path, icon, title},
  token
}) => {
  const to = useTo(path);
  const {pathname} = useContext(context);
  const isCurrentPath = useMemo(
    () => pathname === to || (homePaths.includes(to) && homePaths.includes(pathname)),
    [pathname]
  );
  return (
    <LinkDuo {...{to, token}} style={{ textDecoration: "none", color: "white" }}>
      <DrawerItem {...{icon, title, isCurrentPath}}/>
    </LinkDuo>
  );
};

DrawerLink.propTypes = {
  item: PropTypes.object,
  token: PropTypes.string,
};

export default connect(
  state => ({
    token: state.user.profile.token,
  })
)(DrawerLink);